import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './form.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleXmark,
  faRotateRight,
  faHouse,
  faHeadset,
} from '@fortawesome/free-solid-svg-icons';

export default function Failure() {
  useEffect(() => { AOS.init({ duration: 600, once: true }); }, []);

  return (
    <div className="jm-result-page">
      <div className="jm-result-card" data-aos="zoom-in">
        <div className="jm-result-icon-wrap">
          <div className="jm-result-icon fail">
            <FontAwesomeIcon icon={faCircleXmark} />
          </div>
        </div>

        <div className="jm-result-body">
          <h2>Payment Failed</h2>
          <p>
            Your payment could not be processed. Don't worry — no amount has been deducted from your account.
            If money was debited, it will be refunded within 5-7 business days.
          </p>

          <div className="jm-result-actions">
            <Link to="/register" className="jm-rbtn primary">
              <FontAwesomeIcon icon={faRotateRight} />
              Try Again
            </Link>
            <Link to="/" className="jm-rbtn outline">
              <FontAwesomeIcon icon={faHouse} />
              Back to Home
            </Link>
            <a href="mailto:rcaiitkgp.payment@gmail.com" className="jm-rbtn danger-outline">
              <FontAwesomeIcon icon={faHeadset} />
              Contact Support
            </a>
          </div>
        </div>

        <div className="jm-result-foot">
          <p>Need help? Reach out to <a href="mailto:rcaiitkgp.payment@gmail.com">rcaiitkgp.payment@gmail.com</a> with your roll number and we'll assist you.</p>
        </div>
      </div>
    </div>
  );
}
